(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-filter-toggle]');
    const panel = document.querySelector('[data-filter-panel]');
    toggle?.addEventListener('click', () => {
      panel?.classList.toggle('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.pf-contact-form__native').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      const fields = form.querySelectorAll('input, textarea');
      fields.forEach((field) => {
        field.addEventListener('invalid', () => field.setAttribute('aria-invalid', 'true'));
        field.addEventListener('input', () => field.removeAttribute('aria-invalid'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-pf-header]');
    const drawer = document.querySelector('[data-pf-header-drawer]');
    const openButtons = document.querySelectorAll('[data-pf-header-menu]');
    const closeButtons = document.querySelectorAll('[data-pf-header-close]');

    let isScrollTicking = false;
    const setScrollState = () => {
      if (!header) return;

      if (header.classList.contains('pf-header--about-page')) {
        if (header.dataset.scrolled !== 'false') {
          header.dataset.scrolled = 'false';
        }
        return;
      }

      const nextScrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 12 ? 'true' : 'false';
      if (header.dataset.scrolled !== nextScrolled) {
        header.dataset.scrolled = nextScrolled;
      }
    };

    const onScroll = () => {
      if (!isScrollTicking) {
        requestAnimationFrame(() => {
          setScrollState();
          isScrollTicking = false;
        });
        isScrollTicking = true;
      }
    };

    const openDrawer = () => {
      if (!drawer) return;
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
    };

    openButtons.forEach((button) => button.addEventListener('click', openDrawer));
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });

    const updateCartCount = (count) => {
      const countNodes = document.querySelectorAll('.pf-header__cart-count');
      countNodes.forEach((countNode) => {
        if (count > 0) {
          countNode.textContent = count;
          countNode.removeAttribute('hidden');
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.setAttribute('hidden', 'true');
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    document.addEventListener('cart:update', (event) => {
      let count = 0;
      if (event.detail?.resource?.items !== undefined) {
        count = event.detail.resource.items.length;
      } else if (event.detail?.resource?.item_count !== undefined) {
        count = event.detail.resource.items ? event.detail.resource.items.length : Number(event.detail.resource.item_count);
      } else {
        const comingFromProductForm = event.detail?.data?.source === 'product-form-component';
        const currentCountNode = document.querySelector('.pf-header__cart-count');
        const currentCount = currentCountNode ? Number(currentCountNode.textContent) : 0;
        count = comingFromProductForm ? currentCount + Number(event.detail?.data?.itemCount ?? 0) : Number(event.detail?.data?.itemCount ?? 0);
      }
      updateCartCount(count);
    });

    // Handle click to copy discount coupon codes in marquee
    const marqueeCodeButtons = document.querySelectorAll('[data-copy-code]');
    const marqueeToast = document.querySelector('[data-marquee-toast]');
    let toastTimeout = null;

    marqueeCodeButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const code = btn.dataset.copyCode;
        if (!code) return;

        navigator.clipboard.writeText(code).then(() => {
          if (marqueeToast) {
            marqueeToast.textContent = `Code '${code}' copied!`;
            marqueeToast.classList.add('is-visible');
            clearTimeout(toastTimeout);
            toastTimeout = setTimeout(() => {
              marqueeToast.classList.remove('is-visible');
            }, 2000);
          }
        }).catch(() => {
          const textArea = document.createElement('textarea');
          textArea.value = code;
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            if (marqueeToast) {
              marqueeToast.textContent = `Code '${code}' copied!`;
              marqueeToast.classList.add('is-visible');
              clearTimeout(toastTimeout);
              toastTimeout = setTimeout(() => {
                marqueeToast.classList.remove('is-visible');
              }, 2000);
            }
          } catch (err) {}
          document.body.removeChild(textArea);
        });
      });
    });

    const marqueeEl = document.querySelector('.pf-header__marquee');
    const marqueeTrack = document.querySelector('.pf-header__marquee-track');

    if (marqueeEl && marqueeTrack) {
      const speedSeconds = parseFloat(getComputedStyle(marqueeEl).getPropertyValue('--pf-marquee-speed')) || 70;
      const pauseOnHover = marqueeTrack.classList.contains('pf-header__marquee-track--pause-hover');
      let x = 0;
      let halfWidth = 0;
      let lastTime = null;
      let paused = false;

      const measure = () => { halfWidth = marqueeTrack.scrollWidth / 2; };
      measure();
      window.addEventListener('load', measure);
      window.addEventListener('resize', measure, { passive: true });

      if (pauseOnHover) {
        marqueeEl.addEventListener('mouseenter', () => { paused = true; });
        marqueeEl.addEventListener('mouseleave', () => { paused = false; });
      }

      const tick = (now) => {
        if (lastTime === null) lastTime = now;
        const dt = now - lastTime;
        lastTime = now;

        const isModalOpen = document.body.classList.contains('fte-modal-open') || document.documentElement.classList.contains('fte-modal-open');
        if (!paused && !isModalOpen && halfWidth > 0) {
          x -= (halfWidth / (speedSeconds * 1000)) * dt;
          if (x <= -halfWidth) x += halfWidth;
          marqueeTrack.style.transform = 'translate3d(' + x.toFixed(2) + 'px, 0, 0)';
        } else if (isModalOpen) {
          lastTime = null;
        }
        requestAnimationFrame(tick);
      };

      document.addEventListener('visibilitychange', () => { lastTime = null; });
      requestAnimationFrame(tick);
    }

    setScrollState();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pf-hero]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const track = root.querySelector('[data-track]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const autoplay = Number(root.dataset.autoplay || 0);
      let index = 0;
      let timer;

      const activate = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      prev?.addEventListener('click', () => activate(index - 1));
      next?.addEventListener('click', () => activate(index + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => activate(Number(dot.dataset.dot))));

      if (autoplay > 0 && slides.length > 1) {
        timer = window.setInterval(() => activate(index + 1), autoplay);
        root.addEventListener('mouseenter', () => window.clearInterval(timer));
        root.addEventListener('mouseleave', () => { timer = window.setInterval(() => activate(index + 1), autoplay); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-pickle-combo-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runtimeLocale = document.querySelector('[data-koya-bundle]')?.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
    const runtimeCurrency =
      document.querySelector('[data-koya-bundle]')?.dataset.currency ||
      document.querySelector('meta[property="og:price:currency"]')?.content ||
      'INR';
    const moneyFormatter = new Intl.NumberFormat(runtimeLocale, {
      style: 'currency',
      currency: runtimeCurrency,
      maximumFractionDigits: 2,
    });

    const formatMoney = (cents) => {
      try {
        return moneyFormatter.format((Number(cents) || 0) / 100);
      } catch (error) {
        return (document.querySelector('[data-koya-bundle]')?.dataset.currencySymbol || '₹') + ((Number(cents) || 0) / 100).toFixed(2);
      }
    };

    const showToast = (section, message) => {
      const toast = section.querySelector('[data-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2600);
    };

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartLink =
        document.querySelector('.wew-header__right a[href*="/cart"]') ||
        document.querySelector('.rauhath-header__actions a[href*="/cart"]') ||
        document.querySelector('.header-actions__cart-icon');

      if (cartLink) {
        let countNode =
          cartLink.querySelector('.wew-header__cart-count') ||
          cartLink.querySelector('.rauhath-header__cart-count') ||
          cartLink.querySelector('.cart-bubble__text-count');
        if (!countNode) {
          countNode = document.createElement('span');
          countNode.className = 'wew-header__cart-count';
          cartLink.appendChild(countNode);
        }

        if (count > 0) {
          if (countNode.classList?.contains('cart-bubble__text-count')) {
            countNode.textContent = count < 100 ? String(count) : '';
            const cartBubble = countNode.closest('.cart-bubble');
            if (cartBubble) {
              cartBubble.classList.remove('visually-hidden');
            }
          } else {
            countNode.textContent = String(count);
            countNode.hidden = false;
            countNode.removeAttribute('aria-hidden');
          }
        } else {
          if (countNode.classList?.contains('cart-bubble__text-count')) {
            countNode.textContent = '';
            const cartBubble = countNode.closest('.cart-bubble');
            if (cartBubble) {
              cartBubble.classList.add('visually-hidden');
            }
          } else {
            countNode.textContent = '0';
            countNode.hidden = true;
            countNode.setAttribute('aria-hidden', 'true');
          }
        }
      }

      try {
        sessionStorage.setItem(
          'cart-count',
          JSON.stringify({
            value: String(count),
            timestamp: Date.now(),
          })
        );
      } catch (error) {
        // Session storage may be unavailable in some browser modes.
      }
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const initBundle = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const vegRequired = Number(section.dataset.vegRequired || 3);
      const nonVegRequired = Number(section.dataset.nonvegRequired || 1);
      const discountPercent = Number(section.dataset.discountPercent || 0);
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const cartUrl = section.dataset.cartUrl || '/cart';
      const cards = Array.from(section.querySelectorAll('[data-bundle-card]'));
      const vegCards = cards.filter((card) => card.dataset.group === 'veg');
      const nonVegCards = cards.filter((card) => card.dataset.group === 'nonveg');
      const vegCountNode = section.querySelector('[data-veg-count]');
      const nonVegCountNode = section.querySelector('[data-nonveg-count]');
      const totalCountNode = section.querySelector('[data-selected-total-count]');
      const listNode = section.querySelector('[data-bundle-list]');
      const originalTotalNode = section.querySelector('[data-original-total]');
      const comboTotalNode = section.querySelector('[data-combo-total]');
      const savingsNode = section.querySelector('[data-savings-amount]');
      const savingsRow = section.querySelector('[data-savings-row]');
      const addButtons = Array.from(section.querySelectorAll('[data-add-combo]'));
      const addButtonLabels = Array.from(section.querySelectorAll('[data-add-combo-label]'));
      const mobileCount = section.querySelector('[data-mobile-count]');
      const mobileTotal = section.querySelector('[data-mobile-total]');
      const fillButtons = Array.from(section.querySelectorAll('[data-fill-default]'));

      const selected = {
        veg: [],
        nonveg: [],
      };

      const selectedCards = () => [...selected.veg, ...selected.nonveg];

      const cardPrice = (card) => Number(card.dataset.price || 0);

      const isCardDisabled = () => false;
      const isCardSoldOut = (card) => card?.dataset.disabled === 'true';

      const getCardVariantButtons = (card) => Array.from(card.querySelectorAll('[data-variant-option]'));

      const applySelectionState = () => {
        updateSummary();
      };

      const selectVariant = (card, variantButton, event) => {
        if (!card || !variantButton) return;

        event?.preventDefault();
        event?.stopPropagation();

        syncVariantSelection(card, variantButton);
        selectCard(card);
        applySelectionState();
      };

      const activateCard = (card, event) => {
        if (!card) return;

        event?.preventDefault();
        event?.stopPropagation();

        toggleCard(card);
        applySelectionState();
      };

      const syncVariantSelection = (card, variantButton) => {
        if (!card || !variantButton) return;

        const variantId = variantButton.dataset.variantId;
        const variantPrice = Number(variantButton.dataset.variantPrice || 0);
        const variantLabel = variantButton.dataset.variantLabel || variantButton.textContent.trim();

        card.dataset.variantId = variantId;
        card.dataset.price = String(variantPrice);
        card.dataset.variantLabel = variantLabel;

        const priceNode = card.querySelector('[data-card-price]');
        if (priceNode) {
          priceNode.textContent = formatMoney(variantPrice);
        }

        getCardVariantButtons(card).forEach((button) => {
          button.classList.toggle('is-active', button === variantButton);
        });
      };

      const selectCard = (card) => {
        if (!card) return false;

        const group = card.dataset.group;
        const alreadySelected = selectedCards().includes(card);
        if (alreadySelected) return true;

        if (group === 'veg') {
          if (selected.veg.length >= vegRequired) {
            showToast(section, `Select only ${vegRequired} core items.`);
            return false;
          }
          selected.veg.push(card);
        } else {
          if (selected.nonveg.length >= nonVegRequired) {
            showToast(section, `Select only ${nonVegRequired} featured item.`);
            return false;
          }
          selected.nonveg.push(card);
        }

        return true;
      };

      const toggleCard = (card) => {
        if (!card) return false;

        const alreadySelected = selectedCards().includes(card);
        if (alreadySelected) {
          selected.veg = selected.veg.filter((item) => item !== card);
          selected.nonveg = selected.nonveg.filter((item) => item !== card);
          return true;
        }

        return selectCard(card);
      };

      const updateButtons = () => {
        cards.forEach((card) => {
          const isSelected = selectedCards().includes(card);
          card.classList.toggle('is-selected', isSelected);
          card.classList.toggle('is-disabled', isCardSoldOut(card));
          card.classList.toggle('is-soldout', isCardSoldOut(card));
          card.dataset.selected = isSelected ? 'true' : 'false';
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const updateSummary = () => {
        const vegLength = selected.veg.length;
        const nonVegLength = selected.nonveg.length;
        const totalLength = vegLength + nonVegLength;
        const originalTotal = selectedCards().reduce((sum, card) => sum + cardPrice(card), 0);
        const savings = totalLength === vegRequired + nonVegRequired ? Math.round(originalTotal * (discountPercent / 100)) : 0;
        const comboTotal = originalTotal - savings;
        const complete = vegLength === vegRequired && nonVegLength === nonVegRequired;

        if (vegCountNode) vegCountNode.textContent = `${vegLength}/${vegRequired} selected`;
        if (nonVegCountNode) nonVegCountNode.textContent = `${nonVegLength}/${nonVegRequired} selected`;
        if (totalCountNode) totalCountNode.textContent = String(totalLength);
        if (originalTotalNode) originalTotalNode.textContent = formatMoney(originalTotal);
        if (comboTotalNode) comboTotalNode.textContent = formatMoney(comboTotal);
        if (mobileCount) mobileCount.textContent = `${totalLength}/${vegRequired + nonVegRequired} selected`;
        if (mobileTotal) mobileTotal.textContent = formatMoney(comboTotal);

        if (savingsRow) {
          savingsRow.hidden = !complete || savings <= 0;
        }
        if (savingsNode) {
          savingsNode.textContent = formatMoney(savings);
        }

        const canAdd = complete;
        addButtons.forEach((button) => {
          button.disabled = !canAdd;
        });
        const buttonLabel = canAdd
          ? 'Add Set to Cart'
          : `Select ${Math.max(0, vegRequired - vegLength)} core items and ${Math.max(0, nonVegRequired - nonVegLength)} featured accent item`;
        addButtonLabels.forEach((label) => {
          label.textContent = buttonLabel;
        });

        if (listNode) {
          if (!totalLength) {
            listNode.innerHTML = '<p class="koya-bundle__empty">Choose 3 core home pieces and 1 featured accent item.</p>';
          } else {
            listNode.innerHTML = selectedCards()
              .map((card) => {
                const variantMarkup = card.dataset.variantLabel
                  ? ' <small>' + escapeHtml(card.dataset.variantLabel) + '</small>'
                  : '';

                return (
                  '<p class="koya-bundle__summary-item"><span>' +
                  escapeHtml(card.dataset.title) +
                  variantMarkup +
                  '</span><strong>' +
                  formatMoney(card.dataset.price) +
                  '</strong></p>'
                );
              })
              .join('');
          }
        }

        updateButtons();
      };

      section.addEventListener('click', (event) => {
        const variantButton = event.target.closest('[data-variant-option]');
        if (variantButton && section.contains(variantButton)) {
          const card = variantButton.closest('[data-bundle-card]');
          if (!card) return;
          selectVariant(card, variantButton, event);
          return;
        }

        const card = event.target.closest('[data-bundle-card]');
        if (!card || !section.contains(card)) return;
        activateCard(card, event);
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const variantButton = event.target.closest('[data-variant-option]');
        if (variantButton && section.contains(variantButton)) {
          return;
        }

        const card = event.target.closest('[data-bundle-card]');
        if (!card || !section.contains(card)) return;
        event.preventDefault();
        activateCard(card, event);
      });

      fillButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          selected.veg = vegCards.filter((card) => !isCardDisabled(card)).slice(0, vegRequired);
          selected.nonveg = nonVegCards.filter((card) => !isCardDisabled(card)).slice(0, nonVegRequired);
          applySelectionState();
        });
      });

      const addCombo = async () => {
        const complete = selected.veg.length === vegRequired && selected.nonveg.length === nonVegRequired;
        if (!complete) return;

        const items = selectedCards().map((card) => ({ id: Number(card.dataset.variantId), quantity: 1 }));
        const buttonState = addButtons.map((button) => button.disabled);
        const buttonLabelState = addButtonLabels.map((label) => label.textContent);
        addButtons.forEach((button) => {
          button.disabled = true;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
        });
        addButtonLabels.forEach((label) => {
          label.textContent = 'Adding...';
        });

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error('Cart add failed');
          const cart = await response.json();
          showToast(section, 'Set added to cart successfully.');
          syncHeaderCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: {
                source: 'koya-home-bundle',
                itemCount: cart.item_count,
              },
            },
          }));
        } catch (error) {
          showToast(section, 'Added to cart failed. Please try again.');
        } finally {
          addButtons.forEach((button, index) => {
            button.disabled = buttonState[index] ?? false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          });
          addButtonLabels.forEach((label, index) => {
            label.textContent = buttonLabelState[index] ?? label.textContent;
          });
          updateSummary();
        }
      };

      addButtons.forEach((button) =>
        button.addEventListener('click', (event) => {
          event.preventDefault();
          addCombo();
        })
      );

      applySelectionState();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-koya-bundle]').forEach(initBundle);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-bestsellers"] && !Shopify.designMode) return;
  try {
    
  class MyPerfumeRail {
    constructor(section) {
      if (!section || section.dataset.ready === 'true') return;
      this.section = section;
      this.root = section.querySelector('[data-myperfume-carousel]');
      this.track = section.querySelector('[data-myperfume-track]');
      this.prev = section.querySelector('[data-myperfume-prev]');
      this.next = section.querySelector('[data-myperfume-next]');
      if (!this.track) return;
      if (!this.root) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
      this.root.style.scrollBehavior = 'smooth';

      let startX = 0;
      let startY = 0;
      let startScroll = 0;
      let dragging = false;
      let pointerMoved = false;
      let gestureLocked = false;
      let gestureAxis = null;

      this.root.addEventListener('pointerdown', (event) => {
        dragging = true;
        pointerMoved = false;
        gestureLocked = false;
        gestureAxis = null;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = this.root.scrollLeft;
      });

      this.root.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!gestureLocked) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

          gestureLocked = true;
          gestureAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';

          if (gestureAxis === 'x') {
            pointerMoved = true;
            this.root.setPointerCapture(event.pointerId);
            this.root.style.scrollSnapType = 'none';
          } else {
            dragging = false;
            this.root.style.scrollSnapType = 'x mandatory';
            return;
          }
        }

        if (gestureAxis !== 'x') return;

        event.preventDefault();
        this.root.scrollLeft = startScroll - deltaX;
      });

      const stopDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        this.root.style.scrollSnapType = 'x mandatory';
        if (event && this.root.hasPointerCapture(event.pointerId)) {
          this.root.releasePointerCapture(event.pointerId);
        }
        if (pointerMoved && gestureAxis === 'x') {
          this.snapToNearest();
        }
      };

      this.root.addEventListener('pointerup', stopDrag);
      this.root.addEventListener('pointercancel', stopDrag);
      this.root.addEventListener('pointerleave', stopDrag);

      section.dataset.ready = 'true';
    }

    scroll(direction) {
      const card = this.track.firstElementChild;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const amount = (card?.clientWidth || this.root.clientWidth * 0.8) + gap;
      this.root.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    snapToNearest() {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const step = card.clientWidth + gap;
      if (!step) return;
      const nextIndex = Math.round(this.root.scrollLeft / step);
      this.root.scrollTo({ left: nextIndex * step, behavior: 'smooth' });
    }
  }

  const initMyPerfumeRails = (scope = document) => {
    scope.querySelectorAll('[data-myperfume-rail-section]').forEach((node) => new MyPerfumeRail(node));
  };

  const initMyPerfumeBuyNowCards = (scope = document) => {
    scope.querySelectorAll('[data-buy-now-card-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const variantInput = form.querySelector('[data-variant-id-input]');
      const buttons = Array.from(form.closest('.myperfume-bestsellers__card')?.querySelectorAll('[data-size-button]') || []);
      if (!variantInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          variantInput.value = button.dataset.variantId || variantInput.value;
          buttons.forEach((other) => {
            const isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMyPerfumeRails());
  document.addEventListener('DOMContentLoaded', () => initMyPerfumeBuyNowCards());
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeRails(event.target));
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeBuyNowCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-dark-collection"] && !Shopify.designMode) return;
  try {
    
  const initMyPerfumeDarkBuyNowCards = (scope = document) => {
    scope.querySelectorAll('[data-buy-now-card-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      const variantInput = form.querySelector('[data-variant-id-input]');
      const buttons = Array.from(form.closest('.myperfume-dark-card')?.querySelectorAll('[data-size-button]') || []);
      if (!variantInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          variantInput.value = button.dataset.variantId || variantInput.value;
          buttons.forEach((other) => {
            const isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMyPerfumeDarkBuyNowCards());
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeDarkBuyNowCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-footer-promo"] && !Shopify.designMode) return;
  try {
    
  const initStoreFooterFeatureCarousel = (scope = document) => {
    scope.querySelectorAll('.store-footer').forEach((section) => {
      if (section.dataset.featureCarouselReady === 'true') return;
      section.dataset.featureCarouselReady = 'true';

      const track = section.querySelector('.store-footer__features');
      if (!track || track.children.length < 2) return;

      let timer = null;

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        timer = window.setInterval(() => {
          const slides = Array.from(track.children);
          const first = slides[0];
          if (!first) return;

          const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
          const step = first.getBoundingClientRect().width + gap;
          const maxScroll = track.scrollWidth - track.clientWidth - 1;

          if (track.scrollLeft >= maxScroll) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: step, behavior: 'smooth' });
          }
        }, 2800);
      };

      start();
      window.addEventListener('resize', start, { passive: true });
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });
      track.addEventListener('touchcancel', start, { passive: true });
    });
  };

  const initStoreFooterAccordions = (scope = document) => {
    scope.querySelectorAll('.store-footer__menu').forEach((details) => {
      if (details.dataset.ready === 'true') return;
      details.dataset.ready = 'true';

      const syncState = () => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          details.open = false;
        } else {
          details.open = true;
        }
      };

      syncState();
      window.addEventListener('resize', syncState, { passive: true });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initStoreFooterFeatureCarousel());
  document.addEventListener('DOMContentLoaded', () => initStoreFooterAccordions());
  document.addEventListener('shopify:section:load', (event) => initStoreFooterFeatureCarousel(event.target));
  document.addEventListener('shopify:section:load', (event) => initStoreFooterAccordions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pf-carousel]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const tabs = root.querySelectorAll('.pf-carousel__tab-btn');
      const panes = root.querySelectorAll('.pf-carousel__pane');

      // Progress bar logic
      const updateProgressBar = (pane) => {
        if (!pane) return;
        const track = pane.querySelector('[data-track]');
        const thumb = pane.querySelector('[data-thumb]');
        if (!track || !thumb) return;

        let ticking = false;
        const update = () => {
          const scrollLeft = track.scrollLeft;
          const maxScroll = track.scrollWidth - track.clientWidth;
          const percentage = maxScroll > 0 ? (scrollLeft / maxScroll) : 0;
          const maxTranslateXPercent = (70 / 30) * 100;
          thumb.style.transform = `translate3d(${percentage * maxTranslateXPercent}%, 0, 0)`;
        };

        track.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(() => {
              update();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
        // Initial run
        update();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.tabIndex;

          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          panes.forEach((p) => p.classList.toggle('is-active', p.dataset.paneIndex === index));
          
          const activePane = root.querySelector(`.pf-carousel__pane.is-active`);
          updateProgressBar(activePane);
        });
      });

      panes.forEach((pane) => {
        updateProgressBar(pane);

        const track = pane.querySelector('[data-track]');
        const prev = root.querySelector('[data-prev]');
        const next = root.querySelector('[data-next]');
        if (track) {
          const step = () => track.querySelector('.pop-card')?.getBoundingClientRect().width || 320;
          prev?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
          next?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rauhath-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateCartCount = (itemCount) => {
      const cartLink = document.querySelector('.rauhath-header__actions a[href*="/cart"]');
      if (!cartLink) return;

      let countNode = cartLink.querySelector('.rauhath-header__cart-count');
      if (!countNode) {
        countNode = document.createElement('span');
        countNode.className = 'rauhath-header__cart-count';
        cartLink.appendChild(countNode);
      }

      if (itemCount > 0) {
        countNode.textContent = String(itemCount);
        countNode.hidden = false;
        countNode.removeAttribute('aria-hidden');
      } else {
        countNode.textContent = '0';
        countNode.hidden = true;
        countNode.setAttribute('aria-hidden', 'true');
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-custom-gift-combo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, locale, currency) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return (currency === 'INR' ? '₹' : '$') + ((Number(cents) || 0) / 100).toFixed(2);
      }
    };

    const showToast = (section, message) => {
      let toast = section.querySelector('[data-gift-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'wew-gift-combo__toast';
        toast.dataset.giftToast = 'true';
        section.appendChild(toast);
      }

      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2400);
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartTrigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('.wew-header__right a[href*="/cart"]') ||
        document.querySelector('.wew-mobile-tabs a[href*="/cart"]');

      if (!cartTrigger) return;

      const countNode =
        cartTrigger.querySelector('.wew-header__cart-count') ||
        cartTrigger.querySelector('.wew-mobile-tabs__badge');

      if (countNode) countNode.textContent = String(count);
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      const cartLink = document.querySelector('.wew-mobile-tabs a[href*="/cart"]');
      if (cartLink) {
        window.location.href = cartLink.href;
      }
    };

    const setupLoopCarousel = (carousel) => {
      if (!(carousel instanceof HTMLElement) || carousel.dataset.loopReady === 'true') return;
      const originals = Array.from(carousel.children).filter(
        (child) => child instanceof HTMLElement && child.hasAttribute('data-gift-card')
      );

      if (originals.length < 3) return;

      carousel.dataset.loopReady = 'true';

      const cloneCards = (cards) =>
        cards.map((card) => {
          const clone = card.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.removeAttribute('data-gift-card');
            clone.dataset.giftCardClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('role', 'presentation');
          }
          return clone;
        });

      const prepend = document.createDocumentFragment();
      const append = document.createDocumentFragment();

      cloneCards(originals).reverse().forEach((clone) => prepend.appendChild(clone));
      cloneCards(originals).forEach((clone) => append.appendChild(clone));

      carousel.prepend(prepend);
      carousel.append(append);

      const measureLoopWidth = () => {
        const cardWidth = originals[0].getBoundingClientRect().width;
        const styles = getComputedStyle(carousel);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return (cardWidth + gap) * originals.length;
      };

      const resetToMiddle = () => {
        const width = measureLoopWidth();
        carousel.scrollLeft = width;
      };

      requestAnimationFrame(resetToMiddle);

      let rafId = 0;
      const normalizeScroll = () => {
        window.cancelAnimationFrame(rafId);
        rafId = window.requestAnimationFrame(() => {
          const width = measureLoopWidth();
          const total = carousel.scrollWidth;
          const leftEdge = width * 0.45;
          const rightEdge = total - carousel.clientWidth - width * 0.45;

          if (carousel.scrollLeft <= leftEdge) {
            carousel.scrollLeft += width;
          } else if (carousel.scrollLeft >= rightEdge) {
            carousel.scrollLeft -= width;
          }
        });
      };

      carousel.addEventListener('scroll', normalizeScroll, { passive: true });
      window.addEventListener('resize', resetToMiddle, { passive: true });
    };

    const initGiftCombo = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-gift-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-gift-panel]'));
      const cards = Array.from(section.querySelectorAll('.wew-gift-combo__carousel > [data-gift-card]'));
      const selectedIds = [];

      const locale = section.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
      const currency = section.dataset.currency || 'INR';
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const discountThreshold = Number(section.dataset.discountThreshold || 99900);
      const discountPercent = Number(section.dataset.discountPercent || 5);

      const summaryList = section.querySelector('[data-gift-summary-list]');
      const subtotalNode = section.querySelector('[data-gift-subtotal]');
      const savingsNode = section.querySelector('[data-gift-savings]');
      const totalNode = section.querySelector('[data-gift-total]');
      const discountRow = section.querySelector('[data-gift-discount-row]');
      const progressFill = section.querySelector('[data-gift-progress]');
      const progressCopy = section.querySelector('[data-gift-progress-copy]');
      const countNode = section.querySelector('[data-gift-count]');
      const addButton = section.querySelector('[data-gift-add]');
      const addLabel = section.querySelector('[data-gift-add-label]');
      const resetButton = section.querySelector('[data-gift-reset]');

      const cardsById = new Map(cards.map((card) => [card.dataset.giftId, card]));
      const carousel = section.querySelector('[data-gift-carousel]');
      if (carousel) {
        setupLoopCarousel(carousel);
      }

      const selectedCards = () => selectedIds.map((id) => cardsById.get(id)).filter(Boolean);

      const updateCardState = () => {
        cards.forEach((card) => {
          const isSelected = selectedIds.includes(card.dataset.giftId);
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const renderSummary = () => {
        const items = selectedCards();
        const subtotal = items.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const thresholdReached = subtotal >= discountThreshold;
        const savings = thresholdReached ? Math.round((subtotal * discountPercent) / 100) : 0;
        const total = subtotal - savings;
        const progress = discountThreshold > 0 ? Math.min((subtotal / discountThreshold) * 100, 100) : 0;

        if (countNode) countNode.textContent = `${items.length} selected`;
        if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, locale, currency);
        if (savingsNode) savingsNode.textContent = formatMoney(savings, locale, currency);
        if (totalNode) totalNode.textContent = formatMoney(total, locale, currency);
        if (progressFill) progressFill.style.width = `${progress}%`;
        if (discountRow) discountRow.hidden = !thresholdReached || savings <= 0;

        if (progressCopy) {
          if (!items.length) {
            progressCopy.textContent = 'Start selecting products';
          } else if (thresholdReached) {
            progressCopy.textContent = `${discountPercent}% savings unlocked`;
          } else {
            const remaining = Math.max(discountThreshold - subtotal, 0);
            progressCopy.textContent = `${formatMoney(remaining, locale, currency)} left to unlock ${discountPercent}% off`;
          }
        }

        if (summaryList) {
          if (!items.length) {
            summaryList.innerHTML =
              '<p class="wew-gift-combo__empty">Choose products from one or more occasion tabs. The combo stays in sync as you add or remove items.</p>';
          } else {
              summaryList.innerHTML = items
              .map((card) => {
                const title = card.dataset.title || 'Product';
                const price = card.dataset.price || 0;
                return `
                  <p class="wew-gift-combo__summary-item" data-selected-item="${card.dataset.giftId}">
                    <span>
                      ${escapeHtml(title)}
                      <small>${escapeHtml(card.dataset.collection || '')}</small>
                    </span>
                    <strong>
                      ${formatMoney(price, locale, currency)}
                      <button type="button" data-remove-gift-id="${card.dataset.giftId}" aria-label="Remove ${escapeHtml(title)}">Remove</button>
                    </strong>
                  </p>
                `;
              })
              .join('');
          }
        }

        if (addButton) {
          addButton.disabled = items.length === 0;
        }
        if (addLabel) {
          if (!items.length) {
            addLabel.textContent = 'Pick items to continue';
          } else {
          addLabel.textContent = thresholdReached ? 'Add combo with savings' : 'Add room combo';
          }
        }

        updateCardState();
      };

      const activatePanel = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.target === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      const addCard = (card) => {
        if (card.dataset.available === 'false') {
          showToast(section, 'This product is sold out.');
          return;
        }

        if (selectedIds.includes(card.dataset.giftId)) return;

        selectedIds.push(card.dataset.giftId);
        renderSummary();
      };

      const removeCard = (giftId) => {
        const index = selectedIds.indexOf(giftId);
        if (index === -1) return;
        selectedIds.splice(index, 1);
        renderSummary();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activatePanel(tab.dataset.target));
      });

      section.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-gift-id]');
        if (removeButton) {
          event.preventDefault();
          removeCard(removeButton.dataset.removeGiftId);
          return;
        }

        const toggleButton = event.target.closest('[data-gift-card-toggle]');
        if (toggleButton) {
          const card = toggleButton.closest('[data-gift-card]');
          if (!card) return;
          event.preventDefault();
          if (selectedIds.includes(card.dataset.giftId)) {
            removeCard(card.dataset.giftId);
          } else {
            addCard(card);
          }
          return;
        }

        const card = event.target.closest('[data-gift-card]');
        if (!card) return;

        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-gift-card]');
        if (!card) return;
        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      addButton?.addEventListener('click', async () => {
        const items = selectedCards().map((card) => ({
          id: Number(card.dataset.variantId),
          quantity: 1,
        }));

        addButton.disabled = true;
        addButton.dataset.loading = 'true';

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const cart = await response.json();
          if (!response.ok || cart?.status) {
            throw new Error(cart?.description || cart?.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'wew-gift-combo',
                  itemCount: cart.item_count,
                },
              },
            })
          );

          syncHeaderCartCount(cart.item_count);
          showToast(section, 'Your room combo was added to cart.');
          openCartDrawer();
        } catch (error) {
          console.error(error);
          showToast(section, 'We could not add the combo. Please try again.');
        } finally {
          addButton.disabled = selectedIds.length === 0;
          addButton.dataset.loading = 'false';
          renderSummary();
        }
      });

      resetButton?.addEventListener('click', () => {
        selectedIds.length = 0;
        renderSummary();
      });

      const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (initialTab?.dataset.target) {
        activatePanel(initialTab.dataset.target);
      }

      renderSummary();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-wew-gift-combo]').forEach(initGiftCombo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-premium-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('.wew-header--hero-overlay');
    let lastScrollY = window.scrollY;

    const applyHeroHeaderState = () => {
      if (!header) return;

      if (header.classList.contains('wew-header--about-page')) {
        header.dataset.scrollDirection = 'none';
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
        return;
      }

      const currentScrollY = window.scrollY;
      const isAtTop = currentScrollY <= 12;
      const isScrollingUp = currentScrollY < lastScrollY;
      const isScrollingDown = currentScrollY > lastScrollY;

      header.dataset.scrollDirection = isAtTop ? 'none' : isScrollingUp ? 'up' : isScrollingDown ? 'down' : header.dataset.scrollDirection || 'none';

      if (isAtTop) {
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
      } else if (isScrollingUp) {
        header.dataset.scrolled = 'true';
        header.dataset.stickyState = 'active';
      } else if (isScrollingDown) {
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
      }

      lastScrollY = currentScrollY;
    };

    const updateCartCount = (itemCount) => {
      const cartButtons = document.querySelectorAll('.wew-header__cart-button, .wew-mobile-tabs__item[href*="/cart"], .wew-mobile-tabs__item[aria-label="Cart"]');
      
      cartButtons.forEach((cartBtn) => {
        let countNode = cartBtn.querySelector('.wew-header__cart-count, .wew-mobile-tabs__badge');
        
        if (!countNode) {
          countNode = document.createElement('span');
          if (cartBtn.classList.contains('wew-mobile-tabs__item')) {
            countNode.className = 'wew-mobile-tabs__badge';
            const iconWrapper = cartBtn.querySelector('.wew-mobile-tabs__icon');
            if (iconWrapper) {
              iconWrapper.appendChild(countNode);
            } else {
              cartBtn.appendChild(countNode);
            }
          } else {
            countNode.className = 'wew-header__cart-count';
            cartBtn.appendChild(countNode);
          }
        }

        if (itemCount > 0) {
          countNode.textContent = String(itemCount);
          countNode.style.display = '';
          countNode.hidden = false;
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.style.display = 'none';
          countNode.hidden = true;
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const readSessionCount = () => {
      try {
        const raw = sessionStorage.getItem('cart-count');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const value = Number(parsed?.value);
        return Number.isFinite(value) ? value : null;
      } catch (error) {
        return null;
      }
    };

    const syncFromServer = async () => {
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;
        const cart = await response.json();
        updateCartCount(Number(cart?.item_count) || 0);
      } catch (error) {
        // Ignore network failures; the session/event-based sync will still work.
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    window.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    const initialCount = readSessionCount();
    if (initialCount !== null) {
      updateCartCount(initialCount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFromServer, { once: true });
    } else {
      syncFromServer();
    }

    const openMobileMenu = () => {
      const drawer = document.querySelector('header-drawer.header-drawer');
      const details = drawer?.querySelector('details.menu-drawer-container');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      if (details) {
        details.open = true;
        details.setAttribute('open', '');
        details.classList.add('menu-open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      window.location.href = document.querySelector('.wew-mobile-tabs a[href*="/cart"]')?.href || '/cart';
    };

    document.querySelectorAll('[data-open-mobile-menu]').forEach((button) => {
      button.addEventListener('click', openMobileMenu);
    });

    document.querySelectorAll('[data-open-cart-drawer]').forEach((button) => {
      button.addEventListener('click', openCartDrawer);
    });

    document.querySelectorAll('[data-cart-drawer-recommendations]').forEach((drawer) => {
      const track = drawer.querySelector('.cart-drawer__recommendations-track');
      const prev = drawer.querySelector('[data-cart-drawer-recommendations-prev]');
      const next = drawer.querySelector('[data-cart-drawer-recommendations-next]');
      const slides = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-slide]'));
      const dots = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-dot]'));

      if (!track || slides.length === 0) return;

      const getStep = () => {
        const slide = slides[0];
        const slideWidth = slide.getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
        return slideWidth + gap;
      };

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const setArrowState = () => {
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };

      const getActiveIndex = () => {
        const viewportCenter = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - viewportCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const updateActiveState = () => {
        setActiveDot(getActiveIndex());
        setArrowState();
      };

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.cartDrawerRecommendationDot || 0);
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateActiveState);
      }, { passive: true });

      window.addEventListener('resize', updateActiveState, { passive: true });
      updateActiveState();
    });

    if (header) {
      applyHeroHeaderState();
      window.addEventListener('scroll', applyHeroHeaderState, { passive: true });
      window.addEventListener('resize', applyHeroHeaderState, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-premium-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wew-hero]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const track = root.querySelector('[data-track]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const prevBtn = root.querySelector('[data-action="prev"]');
    const nextBtn = root.querySelector('[data-action="next"]');
    const counterEl = root.querySelector('[data-counter-current]');
    const transitionEffect = root.dataset.transition || 'fade';
    const autoplaySpeed = Number(root.dataset.autoplay) || 0;
    const autoplayMs = autoplaySpeed > 0 ? autoplaySpeed : 8000;

    if (slides.length <= 1 || !track) return;

    let index = 0;
    let timer = null;
    let pointerId = null;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragDeltaX = 0;
    let dragDeltaY = 0;
    let isDragging = false;
    let isHorizontalGesture = false;

    // Set CSS var for dot fill animation duration
    root.style.setProperty('--wew-autoplay', autoplayMs + 'ms');

    let autoplayStarted = false;

    const startTimer = () => {
      stopTimer();
      if (autoplayMs > 0 && slides.length > 1) {
        timer = setTimeout(() => {
          activate(index + 1);
        }, autoplayMs);
      }
    };

    const stopTimer = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    const activate = (nextIndex, isManual = false) => {
      const newIndex = (nextIndex + slides.length) % slides.length;
      index = newIndex;

      if (transitionEffect === 'slide') {
        track.style.transform = `translateX(-${index * 100}%)`;
      }

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.remove('is-active');
        if (active) {
          if (autoplayStarted || isManual) {
            void dot.offsetWidth; // Trigger reflow so progress bar restarts cleanly
          }
          dot.classList.add('is-active');
        }
        dot.setAttribute('aria-selected', String(active));
      });

      if (counterEl) {
        const num = String(index + 1).padStart(2, '0');
        counterEl.textContent = num;
      }

      if (autoplayStarted || isManual) {
        autoplayStarted = true;
        startTimer();
      }
    };

    const triggerAutoplay = () => {
      if (autoplayStarted) return;
      autoplayStarted = true;
      ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach((ev) => {
        window.removeEventListener(ev, triggerAutoplay);
      });
      startTimer();
    };

    ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach((ev) => {
      window.addEventListener(ev, triggerAutoplay, { passive: true, once: true });
    });

    prevBtn?.addEventListener('click', () => activate(index - 1, true));
    nextBtn?.addEventListener('click', () => activate(index + 1, true));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => activate(Number(dot.dataset.dot), true));
    });

    // Pause autoplay on mouse hover, resume on leave
    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', startTimer);

    // Pause autoplay when browser tab is inactive
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopTimer();
      } else {
        startTimer();
      }
    });

    // Touch & pointer dragging with vertical scroll preservation
    root.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerId = e.pointerId;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragDeltaX = 0;
      dragDeltaY = 0;
      isDragging = true;
      isHorizontalGesture = false;
      stopTimer();
      if (transitionEffect === 'slide') {
        track.style.transition = 'none';
      }
    });

    root.addEventListener('pointermove', (e) => {
      if (!isDragging || e.pointerId !== pointerId) return;
      dragDeltaX = e.clientX - dragStartX;
      dragDeltaY = e.clientY - dragStartY;

      if (!isHorizontalGesture) {
        if (Math.abs(dragDeltaX) > 8 || Math.abs(dragDeltaY) > 8) {
          if (Math.abs(dragDeltaX) > Math.abs(dragDeltaY) * 1.2) {
            isHorizontalGesture = true;
          } else {
            // User is scrolling vertically - cancel slide drag
            isDragging = false;
            pointerId = null;
            if (transitionEffect === 'slide') {
              track.style.transition = '';
              track.style.transform = `translateX(-${index * 100}%)`;
            }
            startTimer();
            return;
          }
        }
      }

      if (isHorizontalGesture && transitionEffect === 'slide') {
        const offset = -index * 100 + (dragDeltaX / root.offsetWidth) * 100;
        track.style.transform = `translateX(${offset}%)`;
      }
    });

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      pointerId = null;

      if (transitionEffect === 'slide') {
        track.style.transition = '';
      }

      const threshold = 35;
      if (isHorizontalGesture && dragDeltaX < -threshold) {
        activate(index + 1, true);
      } else if (isHorizontalGesture && dragDeltaX > threshold) {
        activate(index - 1, true);
      } else {
        activate(index, true);
      }

      dragDeltaX = 0;
      dragDeltaY = 0;
      isHorizontalGesture = false;
    };

    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);

    // Re-activate on orientation/window resize
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      const currentWidth = window.innerWidth;
      if (currentWidth !== lastWidth) {
        lastWidth = currentWidth;
        activate(index, true);
      }
    }, { passive: true });

    activate(0, false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiSpotlight = (scope = document) => {
      scope.querySelectorAll('[data-wew-spotlight]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-spotlight-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-spotlight-panel]'));
        const seeAll = section.querySelector('[data-spotlight-see-all]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.spotlightTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;

            if (isActive && seeAll && panel.dataset.spotlightUrl) {
              seeAll.href = panel.dataset.spotlightUrl;
            }
          });
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => activate(tab.dataset.spotlightTarget));
        });

        section.querySelectorAll('[data-wew-spotlight-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;
            button.dataset.loading = 'true';

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) {
                throw new Error(cart?.description || cart?.message || 'Add to cart failed');
              }

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'wew-spotlight',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
              button.dataset.loading = 'false';
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.spotlightTarget) {
          activate(activeTab.dataset.spotlightTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiSpotlight());
    document.addEventListener('shopify:section:load', (event) => initChibiSpotlight(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-story-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiStories = (scope = document) => {
      scope.querySelectorAll('[data-wew-story-collections]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-story-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-story-panel]'));
        const seeAll = section.querySelector('[data-story-see-all]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.storyTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);

            if (isActive && seeAll && panel.dataset.storyUrl) {
              seeAll.href = panel.dataset.storyUrl;
            }
          });
        };

        tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.storyTarget)));

        section.querySelectorAll('[data-wew-story-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) throw new Error(cart?.description || cart?.message || 'Add to cart failed');

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'wew-story-collections',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.storyTarget) {
          activate(activeTab.dataset.storyTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiStories());
    document.addEventListener('shopify:section:load', (event) => initChibiStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-drawer"]) return;
  try {
    
(function() {
  const drawer   = document.getElementById('wishlist-drawer');
  const backdrop = document.getElementById('wishlist-drawer-backdrop');
  const closeBtn = document.getElementById('wishlist-drawer-close');
  const grid     = document.getElementById('wishlist-drawer-grid');
  const empty    = document.getElementById('wishlist-drawer-empty');

  if (!drawer) return;

  function openDrawer() {
    drawer.setAttribute('open', '');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderGrid();
  }

  function closeDrawer() {
    drawer.removeAttribute('open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close on backdrop / close button / Escape
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  drawer.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  function renderGrid() {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem('wishlist') || '[]');
    } catch (e) {
      list = [];
    }
    if (list.length === 0) {
      grid.innerHTML = '';
      grid.style.display  = 'none';
      empty.style.display = '';
      return;
    }
    grid.style.display  = '';
    empty.style.display = 'none';
    grid.innerHTML = list.map(item => {
      const t  = (item.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const img = item.image || '';
      return `
        <div class="wl-drawer-card">
          <a class="wl-drawer-card__img-link" href="/products/${item.handle}">
            ${img ? `<img class="wl-drawer-card__img" src="${img}" alt="${t}" loading="lazy">` : ''}
          </a>
          <div class="wl-drawer-card__info">
            <a class="wl-drawer-card__title" href="/products/${item.handle}">${t}</a>
            <span class="wl-drawer-card__price">${item.price || ''}</span>
          </div>
          <button
            class="wl-drawer-card__remove"
            type="button"
            aria-label="Remove from wishlist"
            aria-pressed="true"
            data-wishlist-button
            data-product-handle="${item.handle}"
            data-product-id="${item.id || ''}"
            data-product-title="${t}"
            data-product-image="${img}"
            data-product-price="${item.price || ''}"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M12 20.5s-7.6-4.6-10-9.2C.5 8 1.7 4.6 5 3.5c2.2-.7 4.3.2 5.6 2 .4.5 1 1.4 1.4 2.1.4-.7 1-1.6 1.4-2.1 1.3-1.8 3.4-2.7 5.6-2 3.3 1.1 4.5 4.5 3 7.8-2.4 4.6-10 9.2-10 9.2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>`;
    }).join('');
  }

  // Re-render when wishlist changes
  document.addEventListener('wishlist:update', renderGrid);

  // Listen for the open trigger (header button dispatches this)
  document.addEventListener('wishlist-drawer:open', openDrawer);

  // Expose globally so the header button can call it
  window.openWishlistDrawer = openDrawer;
})();

  } catch(e) { console.error(e); }
})();
})();
